import { postContent } from "../../lib/fetchData";
import { IInventoryContext } from "./context";
import { InventoryPartialRequest } from "./ProductInventory/types";

export const ApiContext: IInventoryContext = {
  getStoresForCart: (request: IDeliveryAddress) => {
    return postContent<IDeliveryAddress, InventoryResult[]>(
      "/api/Inventory/GetStoresForCart",
      request
    );
  },
  getInventory: (request: ProductInventoryRequest) => {
    return postContent<ProductInventoryRequest, InventoryResult[]>(
      "/api/Inventory/GetProductInventory",
      request
    );
  },
  getPartialInventory: (request: InventoryPartialRequest) => {
    return postContent<InventoryPartialRequest, InventoryResult>(
      "/api/Inventory/GetVendorInventory2",
      request
    );
  },
};
